import { getFiltersFromStorage } from "@/components/AgendaFilters/utils/getFiltersFromStorage";
import { setFiltersFromStorage } from "@/components/AgendaFilters/utils/setFiltersFromStorage";

const LAST_SELECTED_BOOKING_FACILITY_ID_KEY =
  "x-whoosh-last-selected-booking-facility-id";
const LAST_SELECTED_BOOKING_COURSE_ID_KEY =
  "x-whoosh-last-selected-booking-course-id";

const normalizeStoredId = (value: string | null | undefined) =>
  value && value.trim().length ? value : null;

export type LastSelectedBookingSelection = {
  facilityId: string | null;
  courseId: string | null;
};

export const getLastSelectedBookingSelection =
  async (): Promise<LastSelectedBookingSelection> => {
    const [facilityId, courseId] = await Promise.all([
      getFiltersFromStorage(LAST_SELECTED_BOOKING_FACILITY_ID_KEY),
      getFiltersFromStorage(LAST_SELECTED_BOOKING_COURSE_ID_KEY),
    ]);

    return {
      facilityId: normalizeStoredId(facilityId),
      courseId: normalizeStoredId(courseId),
    };
  };

export const getStoredCourseIdsForFacility = async (
  facilityId: string
): Promise<string[]> => {
  const storedCourseIds = await getFiltersFromStorage(
    `x-whoosh-${facilityId}-course-ids`
  );

  if (!storedCourseIds) {
    return [];
  }

  return storedCourseIds
    .split(",")
    .filter((courseId: string) => courseId.trim().length);
};

export const setLastSelectedBookingSelection = async ({
  facilityId,
  courseId,
}: {
  facilityId: string;
  courseId?: string | null;
}): Promise<void> => {
  await Promise.all([
    setFiltersFromStorage(LAST_SELECTED_BOOKING_FACILITY_ID_KEY, facilityId),
    setFiltersFromStorage(LAST_SELECTED_BOOKING_COURSE_ID_KEY, courseId ?? ""),
  ]);

  if (courseId) {
    await setFiltersFromStorage(`x-whoosh-${facilityId}-course-ids`, courseId);
  }
};
